import { useCallback } from 'react';
import { axiosInstance, useAxios } from 'api/axios';
import {
  CreateExternalServiceCodePayload,
  ExternalServiceCodeByActivity,
  ExternalServiceCodeGrouped,
  MappingParams,
} from './externalServiceCode.types';

export const useCreateExternalServiceCode = () => {
  const [{ data, loading }, createExternalServiceCodeReq] = useAxios({
    method: 'POST',
  });

  const createExternalServiceCode = useCallback(
    (payload: CreateExternalServiceCodePayload) =>
      createExternalServiceCodeReq({
        url: '/externalItemMapping/create',
        data: payload,
      }),
    [createExternalServiceCodeReq],
  );

  return {
    data: data?.result,
    loading,
    createExternalServiceCode,
  };
};

export const useGetExternalServiceCodesGrouped = () => {
  const [{ data, loading }, getGroupedReq] = useAxios<{
    result: ExternalServiceCodeGrouped[];
  }>({
    method: 'GET',
  });

  const getExternalServiceCodesGrouped = useCallback(
    ({ pageNumber, resultSize }: MappingParams) =>
      getGroupedReq({
        url: '/externalItemMapping/grouped',
        params: { pageNumber, resultSize },
      }),
    [getGroupedReq],
  );

  return {
    data: data?.result,
    count: data?.result.length ?? 0,
    loading,
    getExternalServiceCodesGrouped,
  };
};

export const useUpdateExternalServiceCode = () => {
  const [{ loading }, updateReq] = useAxios({ method: 'PUT' });

  const updateExternalServiceCode = useCallback(
    (id: number | string, payload: CreateExternalServiceCodePayload) =>
      updateReq({
        url: `/externalItemMapping/${id}/update`,
        data: payload,
      }),
    [updateReq],
  );

  return { loading, updateExternalServiceCode };
};

export const useDeleteExternalServiceCode = () => {
  const deleteExternalServiceCode = useCallback(
    (id: number | string) => axiosInstance.delete(`/externalItemMapping/${id}`),
    [],
  );

  return { deleteExternalServiceCode };
};

export const useGetExternalServiceCodesByActivity = () => {
  const [{ data, loading }, getByActivityReq] = useAxios<{
    result: ExternalServiceCodeByActivity[];
  }>({
    method: 'GET',
  });

  const getExternalServiceCodesByActivity = useCallback(
    (activityId: number | string) =>
      getByActivityReq({
        url: `/externalItemMapping/byActivity/${activityId}`,
      }),
    [getByActivityReq],
  );

  return {
    data: data?.result,
    loading,
    getExternalServiceCodesByActivity,
  };
};
